import React from "react";

import Contracts from "features/contracts/Contracts";
import Customer from "features/customer/Customer";
import Dashboard from "features/dashboard/Dashboard";
import Payments from "features/payments/Payments";
import Requirements from "features/requirements/Requirements";
import Invoices from "features/invoices/Invoices";
import ContractualAccounts from "features/contractualAccounts/ContractualAccounts";
import SelfReadingDocs from "features/selfReadings/SelfReadingDocs";
import ProformaInvoices from "features/invoices/ProformaInvoices";
import TermsAndConditions from "features/conditions/TermsAndConditions";
import ConsumptionHistory from "features/consumption/ConsumptionHistory";
import ProductionHistory from "features/consumption/ProductionHistory";
import FuelingContracts from "features/contracts/FuelingContracts";
import ChargningHistory from "features/fueling/ChargningHistory";
import Contracting from "features/contracting/Contracting";
import Exports from "features/exports/Exports";
import AdditionalInfo from "features/additionalInfo/AdditionalInfo";
import ContractProcess from "features/contractProcess/ContractProcess";
import Deposits from "features/deposits/Deposits";
import Ets2Affidavit from "features/ets2/Ets2Affidavit";

function defineModules<T extends Record<string, React.ComponentType<any>>>(m: T) { return m; }

export const ModuleComponentsMap = defineModules({
  Contracts,
  Customer,
  Dashboard,
  Payments,
  Requirements,
  Invoices,
  ContractualAccounts,
  SelfReadingDocs,
  ProformaInvoices,
  TermsAndConditions,
  ConsumptionHistory,
  ProductionHistory,
  EmobilityContracts: FuelingContracts,
  ChargningHistory,
  Contracting,
  Exports,
  AdditionalInfo,
  ContractProcess,
  Deposits,
  Ets2Affidavit
});

export type ModuleName = keyof typeof ModuleComponentsMap;
export type ModuleComponent<N extends ModuleName = ModuleName> = typeof ModuleComponentsMap[N];
export type ModuleComponentProps<N extends ModuleName> = React.ComponentProps<ModuleComponent<N>>;